export default __webpack_public_path__ + "static/media/assembledRed.5cfc6958.svg";